import React, { useState } from 'react';
import Modal from 'components/Modal.jsx';
import Grid from 'components/Grid.jsx';
import { userSelector } from 'modules/currentUser';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import * as localstorage from 'modules/localstorage';
import useI18n from 'hooks/I18n/useI18n';
import Button, { LINK_BLUE_MODE, SMALL_SIZE } from 'src/components/atoms/Button/Button.jsx';

export const AlertModalContainer = () => {
    const user = useSelector(userSelector);
    const [isOpen, setIsOpen] = useState(true);
    const { trans } = useI18n();
    const announcement = user.announcement;
    const hasAnnouncement = user.hasAnnouncement;
    const userId = user.id;

    const handleCloseModal = () => setIsOpen(false);

    const _getAnnouncementDismissedKey = announcementUuid => {
        return `announcement_dismissed_${userId}_${announcementUuid}`;
    };

    const dismissAnnouncement = announcementUuid => {
        const announcementKey = _getAnnouncementDismissedKey(announcementUuid);

        if (!localstorage.getItem(announcementKey)) {
            localstorage.setItem(announcementKey, 'true');
        }
    };

    const onClickAcceptSubmit = e => {
        e.preventDefault();
        dismissAnnouncement(announcement.uuid);
        handleCloseModal(e);
    };

    const getCurrentUserAnnouncement = currentUserAnnouncement => {
        const announcementKey = _getAnnouncementDismissedKey(currentUserAnnouncement.uuid);

        if (localstorage.getItem(announcementKey) !== 'true') {
            return currentUserAnnouncement;
        }

        return null;
    };

    if (!hasAnnouncement) {
        return null;
    }

    const currentUserAnnouncement = getCurrentUserAnnouncement(announcement);

    if (R.isNil(currentUserAnnouncement)) {
        return null;
    }

    return (
        <Modal isOpened={isOpen} closeModal={handleCloseModal}>
            <div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: announcement.content,
                    }}
                />
                <Grid md="6|6" sm="6|6" align="middle">
                    <Button
                        mode={LINK_BLUE_MODE}
                        block
                        underline
                        onClick={handleCloseModal}
                        weight="link"
                    >
                        {trans('announcement.remindMeLater')}
                    </Button>
                    <Button
                        size={SMALL_SIZE}
                        block
                        onClick={onClickAcceptSubmit}
                        variant="success"
                        className="button button--success"
                    >
                        {trans('announcement.dismiss')}
                    </Button>
                </Grid>
            </div>
        </Modal>
    );
};

export default AlertModalContainer;
